import styles from "./Input.module.css";

interface TextInputProps {
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  disable?: boolean;
  label?: string;
}

const TextInput: React.FC<TextInputProps> = ({
  placeholder,
  value,
  onChange,
  type = "text",
  disable = false,
  label,
}) => {
  return (
  <div className={styles.inputWrapper}>
    <input
      type={type}
      placeholder={label ? "" : placeholder}
      value={value}
      onChange={onChange}
      className={styles.singleInput}
      disabled={disable}
    />
    {label && (
      <label className={`${styles.inputLabel} ${value ? styles.active : ""}`}>
        {label}
      </label>
    )}
  </div>
);
};

export default TextInput;